import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=8d0b336e&scoped=true&lang=pug&"
import script from "./TemplateList.vue?vue&type=script&lang=ts&"
export * from "./TemplateList.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateList.vue?vue&type=style&index=0&id=8d0b336e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0b336e",
  null
  
)

export default component.exports